module.exports = __webpack_public_path__ + "static/media/sss-auto-vest.8fbadd21.svg";